import { createFileRoute } from "@tanstack/react-router";
import { SitemapRedirect } from "@/components/layout/SitemapRedirect";

export const Route = createFileRoute("/sitemap-de.xml/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SitemapRedirect country="de" />
  );
}
